// extracted by mini-css-extract-plugin
export default {"niceFont":"HallOfFame_niceFont__a+V6+"};